import React,{Component} from "react";

const UserContext = React.createContext({
   currentUserInfo:null,

})
 
export default UserContext;